<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="StarIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="scheduleJobs.length" v-if="scheduleJobs" />
    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
      <div class="notification-top text-center p-5 bg-primary text-white">
        <p class="opacity-75">IntelliPrice Jobs</p>
      </div>
      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li v-for="ntf in scheduleJobs" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer" @click="runCommandNow(ntf)">
            <div class="flex items-start">
              <div class="mx-2">
                <span v-if="ntf.command === 'hourly' ">Αυτόματη εκτέλεση εργασίας κάθε μια ώρα.</span>
                <span v-if="ntf.command === 'everyTwoHours' ">Αυτόματη εκτέλεση εργασίας κάθε δύο (2) ώρες.</span>
                <span v-if="ntf.command === 'everyThreeHours' ">Αυτόματη εκτέλεση εργασίας κάθε τρεις (3) ώρες.</span>
                <span v-if="ntf.command === 'everyFourHours' ">Αυτόματη εκτέλεση εργασίας κάθε τέσσερις (4) ώρες.</span>
                <span v-if="ntf.command === 'everySixHours' ">Αυτόματη εκτέλεση εργασίας κάθε έξι (6) ώρες.</span>
                <span v-if="ntf.command === 'hourlyAt' ">
                            {{ `Αυτόματη εκτέλεση εργασία κάθε μια ώρα στο ${ntf.minute} λεπτό της ώρας.` }}
                          </span>
                <span v-if="ntf.command === 'daily' ">
                            {{ `Αυτόματη εκτέλεση εργασίας κάθε μέρα τα μεσάνυχτα.` }}
                          </span>
                <span v-if="ntf.command === 'dailyAt' ">
                            {{ `Αυτόματη εκτέλεση εργασίας κάθε μέρα και ώρα ${ntf.hour}.` }}
                          </span>
                <span v-if="ntf.command === 'weekly' ">
                            {{ `Αυτόματη εκτέλεση εργασίας κάθε Kυριακή και ώρα 00:00.` }}
                          </span>
                <span v-if="ntf.command === 'weeklyOn' ">
                  {{`Αυτόματη εκτέλεση εργασίας κάθε ${dates.find(x => x.value == ntf.date).name} και ώρα ${ntf.hour}.` }}
                </span>
                <span v-if="ntf.command === 'monthly' ">
                            {{ `Αυτόματη εκτέλεση εργασίας κάθε μήνα την πρώτη ημέρα` }}
                          </span>
                <span v-if="ntf.command === 'monthlyOn' ">
                            {{
                    `Αυτόματη εκτέλεση εργασίας κάθε μήνα στης ${ntf.date_number} του μηνός και ώρα ${ntf.hour}.`
                  }}
                          </span><br>
                <template v-if="ntf.categories">
                  <small>Η προγραμματισμένη εργασία θα εκτελεστεί μόνο για:
                    <span v-for="category in ntf.categories.split(',')" :key="category">
                        <span v-if="categories.find(x => x.id === parseInt(category))">{{ categories.find(x => x.id === parseInt(category)).name }},</span>
                    </span>
                  </small>
                </template>
                <template v-if="ntf.brands">
                  <small>
                    <span v-for="brand in ntf.brands.split(',')" :key="brand">
                      <span v-if="brands.find(x => x.manufacturer === brand)">{{ brands.find(x => x.manufacturer === brand).manufacturer }},</span>
                    </span>
                  </small>
                </template>
                <template v-if="ntf.groups">
                  <small>
                    <span v-for="group in ntf.groups.split(',')" :key="group">
                      <span v-if="groups.find(x => x.group === group)">{{ groups.find(x => x.group === group).group }},</span>
                    </span>
                  </small>
                </template>
              </div>
              <p class="rounded-full shadow-md cursor-pointer block" style="padding: 5px; background: #d3d3d373; font-weight: bold;">{{ ntf.request_needed }}</p>
            </div>
          </li>
        </ul>
      </component>
      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <a href="/settings/schedule">Προβολή ρυθμίσεων</a>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    scheduleJobs() {
      return this.$store.getters.getScheduleJobs
    },
    categories() {
      return this.$store.getters.getSettingCategories
    },
    brands() {
      return this.$store.getters.getSettingBrands
    },
    groups() {
      return this.$store.getters.getSettingGroups
    },
    dates() {
      return this.$store.getters.getCronDates
    },
  },
  methods: {
    runCommandNow(obj) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Επιβεβαίωση`,
        text: 'Θέλετε να εκτελέσετε την εργασία που επιλέξατε τώρα;',
        acceptText: 'Εκτέλεση εργασίας',
        cancelText: 'Ακύρωση',
        accept: this.runCommandNowOnDemand(obj)
      })
    },
    runCommandNowOnDemand(obj) {
      this.$store.dispatch('fetchCommandOnDemand',obj)
    },
  },
  mounted() {
    this.$store.dispatch('fetchScheduleJobs')
    this.$store.dispatch('fetchSettingCategories')
    this.$store.dispatch('fetchSettingBrands')
    this.$store.dispatch('fetchSettingGroups')
  }
}
</script>
